import {
  type CreateMealServiceRequest,
  type MealServiceApprovalRequest,
  type MealServiceDetail,
  MealServiceDetailSchema,
  type MealServiceFacets,
  MealServiceFacetsSchema,
  type MealServiceListQuery,
  type MealServiceListResponse,
  MealServiceListResponseSchema,
  type UpdateMealServiceRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

export const listMealServices = async (
  query: MealServiceListQuery,
): Promise<MealServiceListResponse> => {
  const { data } = await apiClient.get<unknown>('/meal-services', { params: query });
  return MealServiceListResponseSchema.parse(data);
};

/**
 * Facets for the Country / City list filters - only the countries and cities
 * actually used by meal services (not the whole geography master).
 */
export const getMealServiceFacets = async (): Promise<MealServiceFacets> => {
  const { data } = await apiClient.get<unknown>('/meal-services/facets');
  return MealServiceFacetsSchema.parse(data);
};

export const getMealService = async (id: string): Promise<MealServiceDetail> => {
  const { data } = await apiClient.get<unknown>(`/meal-services/${id}`);
  return MealServiceDetailSchema.parse(data);
};

export const createMealService = async (
  payload: CreateMealServiceRequest,
): Promise<MealServiceDetail> => {
  const { data } = await apiClient.post<unknown>('/meal-services', payload);
  return MealServiceDetailSchema.parse(data);
};

export const updateMealService = async (
  id: string,
  payload: UpdateMealServiceRequest,
): Promise<MealServiceDetail> => {
  const { data } = await apiClient.patch<unknown>(`/meal-services/${id}`, payload);
  return MealServiceDetailSchema.parse(data);
};

export const approveMealService = async (
  id: string,
  payload: MealServiceApprovalRequest,
): Promise<MealServiceDetail> => {
  const { data } = await apiClient.post<unknown>(`/meal-services/${id}/approval`, payload);
  return MealServiceDetailSchema.parse(data);
};

export const deleteMealService = async (id: string): Promise<void> => {
  await apiClient.delete(`/meal-services/${id}`);
};

export const bulkDeleteMealServices = async (
  ids: string[],
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/meal-services/bulk-delete', { ids });
  return data;
};
